import { QueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

/** Não faz sentido re-tentar erro 4xx (input/permissão/rota) — só rede/5xx. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false
  if (error instanceof AxiosError) {
    const status = error.response?.status
    if (status && status >= 400 && status < 500) return false
  }
  return true
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetry,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
